import type { FC } from 'react'

import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'
import Badge from '@segment/matcha/components/Badge'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import ButtonText from '@segment/matcha/components/ButtonText'

import PropCardBase, * as PropCard from '@segment/matcha/recipes/PropCard'

import type { ResourcePromo as ResourcePromoProps } from '@segment/api/types/resource'

import contentfulImageLoader from '@segment/utils/contentfulImageLoader/contentfulImageLoader'

const ResourcePromo: FC<ResourcePromoProps> = ({ title, description, image, label, url, cta }) => {
  return (
    <StyledPropCardBase reverse={true}>
      <PropCard.Copy>
        {label && <Badge variant="outlined">{label}</Badge>}
        <PropCard.Title>{title}</PropCard.Title>
        <PropCard.Text>{description}</PropCard.Text>
        <ButtonText tag="a" href={url} iconEnd={ChevronRightIcon}>
          {cta}
        </ButtonText>
      </PropCard.Copy>
      {image && (
        <PropCard.Img>
          <picture>
            <StyledImage
              loader={() =>
                contentfulImageLoader({
                  src: image.src,
                  width: Number(image.width),
                })
              }
              width={image.width}
              height={image.height}
              src={image.src}
              alt={image.title}
              loading="lazy"
            />
          </picture>
        </PropCard.Img>
      )}
    </StyledPropCardBase>
  )
}

const StyledPropCardBase = styled(PropCardBase)`
  margin-top: 40px;
  border: 2px solid ${({ theme }) => theme.palette.twilio.gray[20]};
`

const StyledImage = styled(Image)`
  height: 100%;
  object-fit: scale-down;
`

export default ResourcePromo
